import React from 'react';
import { Paper, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InteractiveImage } from './InteractiveImage';

interface LeftPanelProps {
  originalImageUrl: string;
  processedImageUrl: string;
  onRetake: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LeftPanel: React.FC<LeftPanelProps> = ({ originalImageUrl, processedImageUrl, onRetake }) => {
  const { t } = useTranslation();
  return (
    <Paper sx={{ p: 2, height: '100%', overflowY: 'auto', boxSizing: 'border-box' }} variant="outlined">
      <Stack spacing={2} sx={{ height: '100%' }}>
        <InteractiveImage
          title={t('ocrDataInput.uploadedImage', 'Uploaded Image')}
          imageUrl={originalImageUrl}
          showRetake={true}
          onRetake={onRetake}
        />
        <InteractiveImage
          title={t('ocrDataInput.processedImage', 'Processed Image')}
          imageUrl={processedImageUrl}
        />
      </Stack>
    </Paper>
  );
};